
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachLectureItemMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_LectureItemMetadata"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemSlug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"itemTitle"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"lectureDuration"},"name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachQuizItemMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_QuizItemMetadata"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemSlug"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachReadingItemMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_ReadingItemMetadata"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemSlug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"itemTitle"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"readingDuration"},"name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachAssignmentItemMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_AssignmentItemMetadata"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemSlug"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachGenericItemMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCoach_GenericItemMetadata"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemSlug"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":576}};
    doc.loc.source = {"body":"fragment CoachLectureItemMetadata on AiCoach_LectureItemMetadata {\n  itemId\n  itemSlug\n  course {\n    slug\n  }\n  itemTitle\n  lectureDuration: duration\n}\n\nfragment CoachQuizItemMetadata on AiCoach_QuizItemMetadata {\n  itemId\n  itemSlug\n}\nfragment CoachReadingItemMetadata on AiCoach_ReadingItemMetadata {\n  itemId\n  itemSlug\n  course {\n    slug\n  }\n  itemTitle\n  readingDuration: duration\n}\n\nfragment CoachAssignmentItemMetadata on AiCoach_AssignmentItemMetadata {\n  itemId\n  itemSlug\n}\n\nfragment CoachGenericItemMetadata on AiCoach_GenericItemMetadata {\n  itemId\n  itemSlug\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CoachLectureItemMetadata"] = oneQuery(doc, "CoachLectureItemMetadata");
        
        module.exports["CoachQuizItemMetadata"] = oneQuery(doc, "CoachQuizItemMetadata");
        
        module.exports["CoachReadingItemMetadata"] = oneQuery(doc, "CoachReadingItemMetadata");
        
        module.exports["CoachAssignmentItemMetadata"] = oneQuery(doc, "CoachAssignmentItemMetadata");
        
        module.exports["CoachGenericItemMetadata"] = oneQuery(doc, "CoachGenericItemMetadata");
        
